import { CONFIGURATION_KEYS, ORGANIZATIONS_BULK } from '../../enums'
import { get } from 'lodash'

export const tabs = [
  {
    id: 1,
    label: 'Detail',
    intlKey: 'tabs.detail',
    path: '/detail',
    type: 'tab'
  },
  {
    id: 2,
    label: 'Registration',
    intlKey: 'tabs.registration',
    path: '/registration',
    type: 'tab'
  },
  {
    id: 3,
    label: 'Payment',
    intlKey: 'tabs.payment',
    path: '/payment',
    type: 'tab'
  },
  {
    id: 4,
    label: 'Awards',
    intlKey: 'tabs.awards',
    path: '/awards',
    type: 'tab'
  },
  {
    id: 5,
    label: 'Award Units',
    intlKey: 'tabs.award_units',
    path: '/award-units',
    type: 'tab'
  },
  {
    id: 7,
    label: 'Award Leaders',
    intlKey: 'tabs.award_leaders',
    path: '/award-leaders',
    type: 'tab'
  },
  {
    id: 8,
    label: 'Participants',
    intlKey: 'tabs.participants',
    path: '/participants',
    type: 'tab'
  }
]

export const tableHeadersOA = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'name'
  },
  {
    id: 3,
    label: 'NAO',
    intlKey: 'table.nao',
    sortableId: 'parentNAO.name'
  }
]

export const tableHeadersGOP = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'name'
  }
]

export const tableHeadersSGOP = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'name'
  },
  {
    id: 3,
    label: 'Global Operating Partner',
    intlKey: 'table.gop_name',
    sortableId: 'name'
  }
]

export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 3,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'name'
  },
  {
    id: 4,
    label: 'OA',
    intlKey: 'table.operating_authorities',
    sortableId: 'parentOA.name'
  },
  {
    id: 5,
    label: 'NAO',
    intlKey: 'table.nao',
    sortableId: 'parentNAO.name'
  }
  // {
  //   id: 11,
  //   label: 'Payments',
  //   intlKey: 'table.payments'
  // },
  // {
  //   id: 10,
  //   label: 'Awards',
  //   intlKey: 'table.awards'
  // },
  // {
  //   id: 5,
  //   label: 'AUs',
  //   intlKey: 'table.aus'
  // },
  // {
  //   id: 6,
  //   label: 'Leaders',
  //   intlKey: 'table.leaders'
  // },
  // {
  //   id: 7,
  //   label: 'Participants',
  //   intlKey: 'table.participants'
  // }
]

export const tableHeadersOrganizationSwitcher = [
  {
    id: 1,
    label: 'Role',
    intlKey: 'table.role'
  },
  {
    id: 2,
    label: 'Organization',
    intlKey: 'table.organization'
  },
  {
    id: 3,
    label: 'Action',
    intlKey: 'table.action'
  }
]

export const bulkOrganizationStateOptions = (configuration, intl) => {
  const options = []



  if (get(configuration, `values[${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)) {
    options.push({
      value: ORGANIZATIONS_BULK.assignLabels.id,
      label: intl.formatMessage({ id: 'label.assign_labels', defaultMessage: 'Assign Labels' })
    })
  }

  if (get(configuration, `values[${CONFIGURATION_KEYS.enableOrganizationLabels.id}].booleanValue`)) {
    options.push({
      value: ORGANIZATIONS_BULK.unassignLabels.id,
      label: intl.formatMessage({ id: 'label.unassign_labels', defaultMessage: 'Unassign Labels' })
    })
  }

  return options
}

export const bulkForm = 'organizations-bulkChange'
